export default __webpack_public_path__ + "static/media/Stock_Car_BR.67b8c46e.png";